import { render, staticRenderFns } from "./OperatorsRegistryEditForm.vue?vue&type=template&id=60b386f0"
import script from "./OperatorsRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./OperatorsRegistryEditForm.vue?vue&type=script&lang=js"
import style0 from "./OperatorsRegistryEditForm.vue?vue&type=style&index=0&id=60b386f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports